import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=f7876cb8&scoped=true&"
import script from "./Unsubscribe.vue?vue&type=script&lang=js&"
export * from "./Unsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=f7876cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7876cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VImg,VRow,VSwitch,VTextField})
